module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['image-cropper', _vm.containerClass]
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "image-viewport",
    on: {
      "mousedown": _vm.grabImage
    }
  }, [_c('img', {
    staticClass: "image",
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slider-container"
  }, [_c('input', {
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.01",
      "min": _vm.minZoom,
      "max": _vm.maxZoom
    },
    domProps: {
      "value": _vm.zoom
    },
    on: {
      "input": function($event) {
        _vm.setZoom($event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e1cfc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/image-cropper/index.vue
// module id = 1991
// module chunks = 2